// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| EzClocker Text CSS Classes
| Note:
|   Requires including the ez-body.css before this file due to
|   dependencies upon css variables.
=================================================================== */
:root {
  /* Font Family Variables */
  /*
  --ezFontFamily: 'Font-Family-ezClocker', 'Roboto', 'Noto Sans', 'Verdana', 'Arial', sans-serif;
  --ezTextFontFamily: 'Font-Family-ezClocker', 'Noto Sans', 'Roboto', 'Verdana', 'Arial', sans-serif;
  */
  /* Banner Text Variables */
  --ezBannerHeaderFontSize: 32pt;
  /* Color: #000000, --ezClockerBlack defined in ez-body.css */
  --ezBannerHeaderColor: var(--ezClockerBlack);
  --ezBannerHeaderFontWeight: bold;
  --ezBannerHeaderFontStyle: normal;
  /* Header Text Variables */
  --ezHeaderFontSize: 22pt;
  /* Color: #000000, --ezClockerBlack defined in ez-body.css */
  --ezHeaderFontColor: var(--ezClockerBlack);
  --ezHeaderFontWeight: bold;
  --ezHeaderFontStyle: normal;
  /* Title Text Variables */
  --ezTitleFontSize: 18pt;
  --ezTitleFontColor: var(--ezClockerNavy);
  --ezTitleFontWeight: bold;
  --ezTitleFontStyle: normal;
  /* Topic Text Variables */
  --ezTopicFontSize: 14pt;
  /* Color: #000000, --ezClockerBlack defined in ez-body.css */
  --ezTopicFontColor: var(--ezClockerBlack);
  /* Color: #ffffff, --ezClockerWhite defined in ez-body.css */
  --ezTopicFontColorWhite: var(--ezClockerWhite);
  --ezTopicFontWeight: bold;
  --ezTopicFontStyle: normal;
  /* Action Text Variables */
  --ezActionFontSize: 14pt;
  /* Color: #2419b2, --ezClockerBlue defined in ez-body.css */
  --ezActionFontColor: var(--ezClockerBlue);
  --ezActionFontWeight: bold;
  --ezActionFontStyle: normal;
  /* Normal Text Variables */
  --ezFontSize: 14pt;
  /* Color: #000000, --ezClockerBlack defined in ez-body.css */
  --ezFontColor: var(--ezClockerBlack);
  /* Color: #6d6e70, --ezClockerGray defined in ez-body.css */
  --ezLightFontColor: var(--ezClockerGray);
  --ezFontWeight: normal;
  --ezFontStyle: normal;
  /* Content Text Variables */
  --ezContentFontSize: 12pt;
  /* Color: #000000, --ezClockerBlack defined in ez-body.css */
  --ezContentFontColor: var(--ezClockerBlack);
  /* Color: #6d6e70, --ezClockerGray defined in ez-body.css */
  --ezContentLightFontColor: var(--ezClockerGray);
  --ezContentFontWeight: normal;
  --ezContentFontStyle: normal;
  /* Small Text Variables */
  --ezSmallFontSize: 10pt;
  --ezMicroFontSize: 8pt;
  --ezMicroFontWeight: normal;
  --ezMicroFontStyle: normal;
  /* Data Related Text Variables */
  /* Color: --ezClockerNavy: #0f4777;, --ezClockerNavyRGB: rgb(15, 71, 119) */
  --ezDataColorNavy: var(--ezClockerNavy);
  /* State or Status Related Text Variables
  /* Color: #00B945, --ezClockerGreen defined in ez-body.css */
  --ezActiveStateColor: var(--ezClockerGreen);
  /* Color: #ffc500, --ezClockerYellow defined in ez-body.css */
  --ezWarnningStateYellow: var(--ezClockerWarnning);
  /* Color: #9b0400, --ezClockerWarnning defined in ez-body.css */
  --ezWarnningStateRed: var(--ezClockerWarnning);
}

li {
  margin-bottom: 4px;
}

/* Header Text Styles */
h1,
.ezText-h1-32pt-ezClockerBlack {
  margin-top: 4px;
  margin-bottom: 4px;
  /* ezBannerHeaderColor defined above */
  color: var(--ezBannerHeaderColor);
  /* ezBannerHeaderColor defined above */
  font-size: var(--ezBannerHeaderFontSize);
  /* ezBannerHeaderColor defined above */
  font-weight: var(--ezBannerHeaderFontWeight);
  /* ezBannerHeaderColor defined above */
  font-style: var(--ezBannerHeaderFontStyle);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezText-h1-32pt-ezClockerNavy {
  margin-top: 4px;
  margin-bottom: 4px;
  /* --ezClockerNavy defined in ez-body.css */
  color: var(--ezClockerNavy);
  /* ezBannerHeaderColor defined above */
  font-size: var(--ezBannerHeaderFontSize);
  /* ezBannerHeaderColor defined above */
  font-weight: var(--ezBannerHeaderFontWeight);
  /* ezBannerHeaderColor defined above */
  font-style: var(--ezBannerHeaderFontStyle);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezText-h1-32pt-ezClockerWhite {
  margin-top: 4px;
  margin-bottom: 4px;
  /* --ezClockerWhite defined in ez-body.css */
  color: var(--ezClockerWhite);
  /* ezBannerHeaderColor defined above */
  font-size: var(--ezBannerHeaderFontSize);
  /* ezBannerHeaderColor defined above */
  font-weight: var(--ezBannerHeaderFontWeight);
  /* ezBannerHeaderColor defined above */
  font-style: var(--ezBannerHeaderFontStyle);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

h2,
.ezText-h2-22pt-ezClockerBlack {
  margin-top: 4px;
  margin-bottom: 4px;
  color: var(--ezHeaderFontColor);
  font-size: var(--ezHeaderFontSize);
  font-weight: var(--ezHeaderFontWeight);
  font-style: var(--ezHeaderFontStyle);
  font-family: var(--ezFontFamily);
}

.ezText-h2-22pt-ezClockerBlack-underlined {
  margin-top: 4px;
  margin-bottom: 4px;
  color: var(--ezHeaderFontColor);
  font-size: var(--ezHeaderFontSize);
  font-weight: var(--ezHeaderFontWeight);
  font-style: var(--ezHeaderFontStyle);
  font-family: var(--ezFontFamily);
  border-bottom: 2px solid #e5e7eb;
  padding-bottom: 6px;
}

h3,
.ezText-h3-18pt-ezClockerNavy {
  margin-top: 4px;
  margin-bottom: 4px;
  color: var(--ezTitleFontColor);
  font-size: var(--ezTitleFontSize);
  font-weight: var(--ezTitleFontWeight);
  font-style: var(--ezTitleFontStyle);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezText-h3-ezClockerBlack {
  margin-top: 4px;
  margin-bottom: 4px;
  /* --ezClockerBlack defined in ez-body.css */
  color: var(--ezClockerBlack);
  font-size: var(--ezTitleFontSize);
  font-weight: var(--ezTitleFontWeight);
  font-style: var(--ezTitleFontStyle);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

h4,
.ezText-h4-14pt-ezClockerBlack {
  margin-top: 4px;
  margin-bottom: 4px;
  color: var(--ezTopicFontColor);
  font-size: var(--ezTopicFontSize);
  font-weight: var(--ezTopicFontWeight);
  font-style: var(--ezTopicFontStyle);
  font-family: var(--ezFontFamily);
}

.ezText-h4-12pt-ezClockerBlack {
  margin-top: 4px;
  margin-bottom: 4px;
  color: var(--ezTopicFontColor);
  font-size: 12pt;
  font-weight: var(--ezTopicFontWeight);
  font-style: var(--ezTopicFontStyle);
  font-family: var(--ezFontFamily);
}

.ezText-main-dialog-message {
  color: var(--ezClockerNavy);
  font-size: 12pt;
  font-weight: bold;
  font-style: normal;
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

/* Header Styles */
.ezH1 {
  margin-top: 4px;
  margin-bottom: 4px;
  color: var(--ezBannerHeaderColor);
  font-size: var(--ezBannerHeaderFontSize);
  font-weight: var(--ezBannerHeaderFontWeight);
  font-style: var(--ezBannerHeaderFontStyle);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezH1-ezClockerWhite {
  margin-top: 4px;
  margin-bottom: 4px;
  color: var(--ezClockerWhite);
  font-size: var(--ezBannerHeaderFontSize);
  font-weight: var(--ezBannerHeaderFontWeight);
  font-style: var(--ezBannerHeaderFontStyle);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezH2 {
  margin-top: 4px;
  margin-bottom: 4px;
  color: var(--ezHeaderFontColor);
  font-size: var(--ezHeaderFontSize);
  font-weight: var(--ezHeaderFontWeight);
  font-style: var(--ezHeaderFontStyle);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezH2-subheader {
  margin-top: 4px;
  margin-bottom: 4px;
  color: var(--ezTitleFontColor);
  font-size: var(--ezHeaderFontSize);
  font-weight: var(--ezHeaderFontWeight);
  font-style: var(--ezHeaderFontStyle);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezH3 {
  margin-top: 4px;
  margin-bottom: 4px;
  color: var(--ezTitleFontColor);
  font-size: var(--ezTitleFontSize);
  font-weight: var(--ezTitleFontWeight);
  font-style: var(--ezTitleFontStyle);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezH3-ezClockerWhite {
  margin-top: 4px;
  margin-bottom: 4px;
  color: var(--ezClockerWhite);
  font-size: var(--ezTitleFontSize);
  font-weight: var(--ezTitleFontWeight);
  font-style: var(--ezTitleFontStyle);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezH3_warning {
  margin-top: 4px;
  margin-bottom: 4px;
  color: var(--ezClockerWarnning);
  font-size: var(--ezTitleFontSize);
  font-weight: var(--ezTitleFontWeight);
  font-style: var(--ezTitleFontStyle);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezH4 {
  margin-top: 4px;
  margin-bottom: 4px;
  color: var(--ezClockerNavy);
  font-size: var(--ezTopicFontSize);
  font-weight: var(--ezTopicFontWeight);
  font-style: var(--ezTopicFontStyle);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezH4ActionBlue {
  margin-top: 4px;
  margin-bottom: 4px;
  color: var(--ezActionFontColor);
  font-size: var(--ezActionFontSize);
  font-weight: var(--ezActionFontWeight);
  font-style: var(--ezActionFontStyle);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

/* Text Alignment Styles */
.ezAlignRight {
  text-align: right;
}

.ezAlignLeft {
  text-align: left;
}

.ezAlignCenter {
  text-align: center;
}

.ezVerticalAlignTop {
  vertical-align: top;
}

.ezVerticalAlignMiddle {
  vertical-align: middle;
}

.ezVerticalAlignBottom {
  vertical-align: bottom;
}

/* Text Label Styles */
.ezLabel {
  color: var(--ezContentFontColor);
  font-family: var(--ezFontFamily);
  font-size: var(--ezContentFontSize);
  font-style: var(--ezContentFontStyle);
  font-weight: var(--ezContentFontWeight);
}

.ezLabel-above-input {
  display: block;
  color: var(--ezContentFontColor);
  font-family: var(--ezFontFamily);
  font-size: var(--ezContentFontSize);
  font-style: var(--ezContentFontStyle);
  font-weight: var(--ezContentFontWeight);
}

.ezDisabledLabel {
  /* --ezClockerStone: #c0c0c0; (defined in ez-body.css) */
  color: var(--ezClockerStone);
}

.ezLabel-scale-80 {
  scale: 80%;
  color: var(--ezContentFontColor);
  font-family: var(--ezFontFamily);
  font-size: var(--ezContentFontSize);
  font-style: var(--ezContentFontStyle);
  font-weight: var(--ezContentFontWeight);
}

/* Text Weight Styles */
.ezBold {
  font-weight: bold;
}

.ezText-strike-out {
  text-decoration: line-through;
}

.ezText-overline {
  text-decoration: overline;
}

.ezText-underline {
  text-decoration: underline;
}

/* Special Text Styles */
.ez-faded-error-details {
  color: var(--ezLightFontColor);
  font-family: var(--ezInputMonospaceFontFamily);
  font-size: var(--ezSmallFontSize);
  font-style: italic;
}

.ezText-legal-disclaimer {
  /* --ezClockerGray: #6d6e70; (defined in ez-body.css) */
  color: var(--ezClockerGray);
  font-size: var(--ezMicroFontSize);
  font-style: italic;
}

.ezText-username-info {
  /* --ezClockerWhite: #ffffff; (defined in ez-body.css) */
  color: var(--ezClockerWhite);
  font-size: var(--ezSmallFontSize);
}

/* Text Classes */
.ezText-bold {
  font-family: var(--ezFontFamily);
  font-weight: bold;
}

.ezText-data-navy {
  color: var(--ezDataColorNavy);
  font-family: var(--ezFontFamily);
  font-weight: normal;
}

.ezText-navy {
  color: var(--ezDataColorNavy);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezText-black {
  color: var(--ezClockerBlack);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezText-bold-ezClockerBlack {
  color: var(--ezClockerBlack);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezText-banner-size-32pt {
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
  font-size: var(--ezBannerHeaderFontSize);
}

.ezText-header-size-22pt {
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
  font-size: var(--ezHeaderFontSize);
}

.ezText-title-size-18pt {
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
  font-size: var(--ezTitleFontSize);
}

.ezText-topic-size-14pt {
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
  font-size: var(--ezTopicFontSize);
}

.ezText-content-size-12pt {
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
  font-size: var(--ezContentFontSize);
}

.ezText-small-size-10pt {
  /* --ezFontFamily: 'Roboto', verdana, sans-serif; (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
  font-size: var(--ezSmallFontSize);
}

.ezText-micro-size-8pt {
  /* --ezFontFamily: 'Roboto', verdana, sans-serif; (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
  font-size: var(--ezMicroFontSize);
}

/* Small Text Classes */
/* Small Black */
.ezText-small-black {
  /* --ezClockerBlack: #000000; (defined in ez-body.css) */
  color: var(--ezClockerBlack);
  font-size: var(--ezSmallFontSize);
}

/* Small White */
.ezText-small-white {
  /* --ezClockerWhite: #ffffff; (defined in ez-body.css) */
  color: var(--ezClockerWhite);
  font-size: var(--ezSmallFontSize);
}

/* Small Gray */
.ezText-small-gray {
  /* --ezClockerGray: #6d6e70; (defined in ez-body.css) */
  color: var(--ezClockerGray);
  font-size: var(--ezSmallFontSize);
}

/* Small Navy */
.ezText-small-navy {
  /* --ezClockerNavy: #0f4777; (defined in ez-body.css) */
  color: var(--ezClockerNavy);
  font-size: var(--ezSmallFontSize);
}

/* Micro Text Classes */
/* Micro Black */
.ezText-micro-black {
  /* --ezClockerBlack: #000000; (defined in ez-body.css) */
  color: var(--ezClockerBlack);
  font-size: var(--ezMicroFontSize);
}

/* Micro Gray */
.ezText-micro-gray {
  /* --ezClockerGray: #6d6e70; (defined in ez-body.css) */
  color: var(--ezClockerGray);
  font-size: var(--ezMicroFontSize);
}

/* Micro Navy */
.ezText-micro-navy {
  /* --ezClockerNavy: #0f4777; (defined in ez-body.css) */
  color: var(--ezDataColorNavy);
  font-size: var(--ezMicroFontSize);
}

/* Micro Navy */
.ezText-micro-white {
  /* --ezClockerWhite: #ffffff; (defined in ez-body.css) */
  color: var(--ezClockerWhite);
  font-size: var(--ezMicroFontSize);
}

.ezText-error-ezDarkAlertRed {
  /* --ezDarkAlertRed: #c60500; (defined in ez-body.css) */
  color: var(--ezDarkAlertRed);
}

.ezText-success-ezClockerGreen {
  /* --ezClockerGreen: #00B945; (defined in ez-body.css) */
  color: var(--ezClockerGreen);
}

.ezText-radio-checkbox-label {
  cursor: pointer;
}

.ezText-ezActiveStatusColor {
  /* --ezDarkAlertRed: #c60500; (defined in ez-body.css) */
  color: var(--ezActiveStateColor);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezText-ezWarningStatusColor {
  /* --ezDarkAlertRed: #c60500; (defined in ez-body.css) */
  color: var(--ezWarnningStateYellow);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezText-ezErrorStatusColor,
.ezText-ezClockerWarnning,
.ezText-warning-dark-alert-red {
  /* --ezDarkAlertRed: #c60500; (defined in ez-body.css) */
  color: var(--ezWarnningStateRed);
  /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */
  font-family: var(--ezFontFamily);
}

.ezText-debug-id {
  opacity: 80%;
  font-size: 8pt;
  font-weight: normal;
}

u.ezText-underline-hide-alt-key-up {
  text-decoration: none;
  font-weight: unset;
}

u.ezText-underline-show-alt-key-down {
  text-decoration: underline;
  font-weight: bold;
}

.ezText-italic {
  font-style: italic;
}

.ezText-content-color {
  color: var(--ezContentFontColor);
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| Horizontal Rule Separator Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
hr.ezText-separator-line-navy {
  margin-top: 10px;
  margin-bottom: 10px;
  min-height: 2px;
  /* Ignoring hint: Do not use width or height when using padding or border */
  height: 2px;
  background-color: var(--ezClockerNavy);
  border-color: var(--ezClockerNavy);
  /* Ignoring hint: Do not use width or height when using padding or border */
  border-style: solid;
  /* Ignoring hint: Do not use width or height when using padding or border */
  border-width: 1px;
  border-radius: 2px;
}

/* ------------------------------------------------------------------
| Large Tablet Screen Styles (https://yesviz.com/laptops.php)
------------------------------------------------------------------ */
/*
@media screen and (max-width: 1023px) {
}
*/
/* ------------------------------------------------------------------
| Small Tablet Screen Styles (https://yesviz.com/tablets.php)
------------------------------------------------------------------ */
/*
@media screen and (max-width: 768px) {
}
*/
/* ------------------------------------------------------------------
| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 480px) {
}
*/
/* ------------------------------------------------------------------
| Warable Screen Style  (https://yesviz.com/watches.php)            |
------------------------------------------------------------------- */
@media screen and (max-width: 319px) {
  .ezH2 {
    margin-top: 2px;
    margin-bottom: 2px;
    color: var(--ezHeaderFontColor);
    font-size: 14pt;
    font-weight: var(--ezHeaderFontWeight);
    font-style: var(--ezHeaderFontStyle);
    font-family: var(--ezFontFamily);
  }
  .ezH2-subheader {
    margin-top: 2px;
    margin-bottom: 2px;
    color: var(--ezTitleFontColor);
    font-size: 14pt;
    font-weight: var(--ezHeaderFontWeight);
    font-style: var(--ezHeaderFontStyle);
    font-family: var(--ezFontFamily);
  }
}`, "",{"version":3,"sources":["webpack://./public/styles/common/ez-text.css"],"names":[],"mappings":"AAAA;;;;;qEAAA;AAOA;EACI,0BAAA;EACA;;;GAAA;EAKA,0BAAA;EACA,8BAAA;EACA,4DAAA;EACA,4CAAA;EACA,gCAAA;EACA,iCAAA;EAEA,0BAAA;EACA,wBAAA;EACA,4DAAA;EACA,0CAAA;EACA,0BAAA;EACA,2BAAA;EAEA,yBAAA;EACA,uBAAA;EACA,wCAAA;EACA,yBAAA;EACA,0BAAA;EAEA,yBAAA;EACA,uBAAA;EACA,4DAAA;EACA,yCAAA;EACA,4DAAA;EACA,8CAAA;EACA,yBAAA;EACA,0BAAA;EAEA,0BAAA;EACA,wBAAA;EACA,2DAAA;EACA,yCAAA;EACA,0BAAA;EACA,2BAAA;EAEA,0BAAA;EACA,kBAAA;EACA,4DAAA;EACA,oCAAA;EACA,2DAAA;EACA,wCAAA;EACA,sBAAA;EACA,qBAAA;EAEA,2BAAA;EACA,yBAAA;EACA,4DAAA;EACA,2CAAA;EACA,2DAAA;EACA,+CAAA;EACA,6BAAA;EACA,4BAAA;EAEA,yBAAA;EACA,uBAAA;EACA,sBAAA;EACA,2BAAA;EACA,0BAAA;EAEA,gCAAA;EACA,2EAAA;EACA,uCAAA;EAEA;8DAAA;EAEA,2CAAA;EACA,6DAAA;EACA,iDAAA;EACA,+DAAA;EACA,8CAAA;AAVJ;;AAaA;EACI,kBAAA;AAVJ;;AAaA,uBAAA;AACA;;EAEI,eAAA;EACA,kBAAA;EACA,sCAAA;EACA,iCAAA;EACA,sCAAA;EACA,wCAAA;EACA,sCAAA;EACA,4CAAA;EACA,sCAAA;EACA,0CAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA;EACI,eAAA;EACA,kBAAA;EACA,2CAAA;EACA,2BAAA;EACA,sCAAA;EACA,wCAAA;EACA,sCAAA;EACA,4CAAA;EACA,sCAAA;EACA,0CAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA;EACI,eAAA;EACA,kBAAA;EACA,4CAAA;EACA,4BAAA;EACA,sCAAA;EACA,wCAAA;EACA,sCAAA;EACA,4CAAA;EACA,sCAAA;EACA,0CAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA;;EAEI,eAAA;EACA,kBAAA;EACA,+BAAA;EACA,kCAAA;EACA,sCAAA;EACA,oCAAA;EACA,gCAAA;AAVJ;;AAaA;EACI,eAAA;EACA,kBAAA;EACA,+BAAA;EACA,kCAAA;EACA,sCAAA;EACA,oCAAA;EACA,gCAAA;EACA,gCAAA;EACA,mBAAA;AAVJ;;AAaA;;EAEI,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,iCAAA;EACA,qCAAA;EACA,mCAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA;EACI,eAAA;EACA,kBAAA;EACA,4CAAA;EACA,4BAAA;EACA,iCAAA;EACA,qCAAA;EACA,mCAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA;;EAEI,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,iCAAA;EACA,qCAAA;EACA,mCAAA;EACA,gCAAA;AAVJ;;AAaA;EACI,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,eAAA;EACA,qCAAA;EACA,mCAAA;EACA,gCAAA;AAVJ;;AAaA;EACI,2BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA,kBAAA;AACA;EACI,eAAA;EACA,kBAAA;EACA,iCAAA;EACA,wCAAA;EACA,4CAAA;EACA,0CAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA;EACI,eAAA;EACA,kBAAA;EACA,4BAAA;EACA,wCAAA;EACA,4CAAA;EACA,0CAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA;EACI,eAAA;EACA,kBAAA;EACA,+BAAA;EACA,kCAAA;EACA,sCAAA;EACA,oCAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA;EACI,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,kCAAA;EACA,sCAAA;EACA,oCAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA;EACI,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,iCAAA;EACA,qCAAA;EACA,mCAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA;EACI,eAAA;EACA,kBAAA;EACA,4BAAA;EACA,iCAAA;EACA,qCAAA;EACA,mCAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA;EACI,eAAA;EACA,kBAAA;EACA,+BAAA;EACA,iCAAA;EACA,qCAAA;EACA,mCAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA;EACI,eAAA;EACA,kBAAA;EACA,2BAAA;EACA,iCAAA;EACA,qCAAA;EACA,mCAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA;EACI,eAAA;EACA,kBAAA;EACA,+BAAA;EACA,kCAAA;EACA,sCAAA;EACA,oCAAA;EACA,2EAAA;EACA,gCAAA;AAVJ;;AAaA,0BAAA;AACA;EACI,iBAAA;AAVJ;;AAaA;EACI,gBAAA;AAVJ;;AAaA;EACI,kBAAA;AAVJ;;AAaA;EACI,mBAAA;AAVJ;;AAaA;EACI,sBAAA;AAVJ;;AAaA;EACI,sBAAA;AAVJ;;AAaA,sBAAA;AACA;EACI,gCAAA;EACA,gCAAA;EACA,mCAAA;EACA,qCAAA;EACA,uCAAA;AAVJ;;AAaA;EACI,cAAA;EACA,gCAAA;EACA,gCAAA;EACA,mCAAA;EACA,qCAAA;EACA,uCAAA;AAVJ;;AAaA;EACI,wDAAA;EACA,4BAAA;AAVJ;;AAaA;EACI,UAAA;EACA,gCAAA;EACA,gCAAA;EACA,mCAAA;EACA,qCAAA;EACA,uCAAA;AAVJ;;AAcA,uBAAA;AACA;EACI,iBAAA;AAXJ;;AAcA;EACI,6BAAA;AAXJ;;AAcA;EACI,yBAAA;AAXJ;;AAcA;EACI,0BAAA;AAXJ;;AAcA,wBAAA;AACA;EACI,8BAAA;EACA,8CAAA;EACA,iCAAA;EACA,kBAAA;AAXJ;;AAcA;EACI,uDAAA;EACA,2BAAA;EACA,iCAAA;EACA,kBAAA;AAXJ;;AAcA;EACI,wDAAA;EACA,4BAAA;EACA,iCAAA;AAXJ;;AAcA,iBAAA;AAEA;EACI,gCAAA;EACA,iBAAA;AAZJ;;AAeA;EACI,6BAAA;EACA,gCAAA;EACA,mBAAA;AAZJ;;AAeA;EACI,6BAAA;EACA,2EAAA;EACA,gCAAA;AAZJ;;AAgBA;EACI,4BAAA;EACA,2EAAA;EACA,gCAAA;AAbJ;;AAgBA;EACI,4BAAA;EACA,2EAAA;EACA,gCAAA;AAbJ;;AAgBA;EACI,2EAAA;EACA,gCAAA;EACA,wCAAA;AAbJ;;AAgBA;EACI,2EAAA;EACA,gCAAA;EACA,kCAAA;AAbJ;;AAgBA;EACI,2EAAA;EACA,gCAAA;EACA,iCAAA;AAbJ;;AAgBA;EACI,2EAAA;EACA,gCAAA;EACA,iCAAA;AAbJ;;AAgBA;EACI,2EAAA;EACA,gCAAA;EACA,mCAAA;AAbJ;;AAgBA;EACI,4EAAA;EACA,gCAAA;EACA,iCAAA;AAbJ;;AAgBA;EACI,4EAAA;EACA,gCAAA;EACA,iCAAA;AAbJ;;AAgBA,uBAAA;AAEA,gBAAA;AACA;EACI,wDAAA;EACA,4BAAA;EACA,iCAAA;AAdJ;;AAiBA,gBAAA;AACA;EACI,wDAAA;EACA,4BAAA;EACA,iCAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,uDAAA;EACA,2BAAA;EACA,iCAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,uDAAA;EACA,2BAAA;EACA,iCAAA;AAdJ;;AAiBA,uBAAA;AAEA,gBAAA;AACA;EACI,wDAAA;EACA,4BAAA;EACA,iCAAA;AAfJ;;AAkBA,eAAA;AACA;EACI,uDAAA;EACA,2BAAA;EACA,iCAAA;AAfJ;;AAkBA,eAAA;AACA;EACI,uDAAA;EACA,6BAAA;EACA,iCAAA;AAfJ;;AAkBA,eAAA;AACA;EACI,wDAAA;EACA,4BAAA;EACA,iCAAA;AAfJ;;AAkBA;EACI,wDAAA;EACA,4BAAA;AAfJ;;AAkBA;EACI,wDAAA;EACA,4BAAA;AAfJ;;AAkBA;EACI,eAAA;AAfJ;;AAkBA;EACI,wDAAA;EACA,gCAAA;EACA,2EAAA;EACA,gCAAA;AAfJ;;AAkBA;EACI,wDAAA;EACA,mCAAA;EACA,2EAAA;EACA,gCAAA;AAfJ;;AAkBA;;;EAKI,wDAAA;EACA,gCAAA;EACA,2EAAA;EACA,gCAAA;AAjBJ;;AAoBA;EACI,YAAA;EACA,cAAA;EACA,mBAAA;AAjBJ;;AAoBA;EACI,qBAAA;EACA,kBAAA;AAjBJ;;AAoBA;EACI,0BAAA;EACA,iBAAA;AAjBJ;;AAoBA;EACI,kBAAA;AAjBJ;;AAoBA;EACI,gCAAA;AAjBJ;;AAqBA;;oEAAA;AAGA;EACI,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,2EAAA;EACA,WAAA;EACA,sCAAA;EACA,kCAAA;EACA,2EAAA;EACA,mBAAA;EACA,2EAAA;EACA,iBAAA;EACA,kBAAA;AAlBJ;;AAqBA;;oEAAA;AAGA;;;CAAA;AAKA;;oEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;EACI;IACI,eAAA;IACA,kBAAA;IACA,+BAAA;IACA,eAAA;IACA,sCAAA;IACA,oCAAA;IACA,gCAAA;EArBN;EAwBE;IACI,eAAA;IACA,kBAAA;IACA,8BAAA;IACA,eAAA;IACA,sCAAA;IACA,oCAAA;IACA,gCAAA;EAtBN;AACF","sourcesContent":["/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| EzClocker Text CSS Classes\n| Note:\n|   Requires including the ez-body.css before this file due to\n|   dependencies upon css variables.\n=================================================================== */\n\n:root {\n    /* Font Family Variables */\n    /*\n    --ezFontFamily: 'Font-Family-ezClocker', 'Roboto', 'Noto Sans', 'Verdana', 'Arial', sans-serif;\n    --ezTextFontFamily: 'Font-Family-ezClocker', 'Noto Sans', 'Roboto', 'Verdana', 'Arial', sans-serif;\n    */\n\n    /* Banner Text Variables */\n    --ezBannerHeaderFontSize: 32pt;\n    /* Color: #000000, --ezClockerBlack defined in ez-body.css */\n    --ezBannerHeaderColor: var(--ezClockerBlack);\n    --ezBannerHeaderFontWeight: bold;\n    --ezBannerHeaderFontStyle: normal;\n\n    /* Header Text Variables */\n    --ezHeaderFontSize: 22pt;\n    /* Color: #000000, --ezClockerBlack defined in ez-body.css */\n    --ezHeaderFontColor: var(--ezClockerBlack);\n    --ezHeaderFontWeight: bold;\n    --ezHeaderFontStyle: normal;\n\n    /* Title Text Variables */\n    --ezTitleFontSize: 18pt;\n    --ezTitleFontColor: var(--ezClockerNavy);\n    --ezTitleFontWeight: bold;\n    --ezTitleFontStyle: normal;\n\n    /* Topic Text Variables */\n    --ezTopicFontSize: 14pt;\n    /* Color: #000000, --ezClockerBlack defined in ez-body.css */\n    --ezTopicFontColor: var(--ezClockerBlack);\n    /* Color: #ffffff, --ezClockerWhite defined in ez-body.css */\n    --ezTopicFontColorWhite: var(--ezClockerWhite);\n    --ezTopicFontWeight: bold;\n    --ezTopicFontStyle: normal;\n\n    /* Action Text Variables */\n    --ezActionFontSize: 14pt;\n    /* Color: #2419b2, --ezClockerBlue defined in ez-body.css */\n    --ezActionFontColor: var(--ezClockerBlue);\n    --ezActionFontWeight: bold;\n    --ezActionFontStyle: normal;\n\n    /* Normal Text Variables */\n    --ezFontSize: 14pt;\n    /* Color: #000000, --ezClockerBlack defined in ez-body.css */\n    --ezFontColor: var(--ezClockerBlack);\n    /* Color: #6d6e70, --ezClockerGray defined in ez-body.css */\n    --ezLightFontColor: var(--ezClockerGray);\n    --ezFontWeight: normal;\n    --ezFontStyle: normal;\n\n    /* Content Text Variables */\n    --ezContentFontSize: 12pt;\n    /* Color: #000000, --ezClockerBlack defined in ez-body.css */\n    --ezContentFontColor: var(--ezClockerBlack);\n    /* Color: #6d6e70, --ezClockerGray defined in ez-body.css */\n    --ezContentLightFontColor: var(--ezClockerGray);\n    --ezContentFontWeight: normal;\n    --ezContentFontStyle: normal;\n\n    /* Small Text Variables */\n    --ezSmallFontSize: 10pt;\n    --ezMicroFontSize: 8pt;\n    --ezMicroFontWeight: normal;\n    --ezMicroFontStyle: normal;\n\n    /* Data Related Text Variables */\n    /* Color: --ezClockerNavy: #0f4777;, --ezClockerNavyRGB: rgb(15, 71, 119) */\n    --ezDataColorNavy: var(--ezClockerNavy);\n\n    /* State or Status Related Text Variables\n    /* Color: #00B945, --ezClockerGreen defined in ez-body.css */\n    --ezActiveStateColor: var(--ezClockerGreen);\n    /* Color: #ffc500, --ezClockerYellow defined in ez-body.css */\n    --ezWarnningStateYellow: var(--ezClockerWarnning);\n    /* Color: #9b0400, --ezClockerWarnning defined in ez-body.css */\n    --ezWarnningStateRed: var(--ezClockerWarnning);\n}\n\nli {\n    margin-bottom: 4px;\n}\n\n/* Header Text Styles */\nh1,\n.ezText-h1-32pt-ezClockerBlack {\n    margin-top: 4px;\n    margin-bottom: 4px;\n    /* ezBannerHeaderColor defined above */\n    color: var(--ezBannerHeaderColor);\n    /* ezBannerHeaderColor defined above */\n    font-size: var(--ezBannerHeaderFontSize);\n    /* ezBannerHeaderColor defined above */\n    font-weight: var(--ezBannerHeaderFontWeight);\n    /* ezBannerHeaderColor defined above */\n    font-style: var(--ezBannerHeaderFontStyle);\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\n    font-family: var(--ezFontFamily);\n}\n\n.ezText-h1-32pt-ezClockerNavy {\n    margin-top: 4px;\n    margin-bottom: 4px;\n    /* --ezClockerNavy defined in ez-body.css */\n    color: var(--ezClockerNavy);\n    /* ezBannerHeaderColor defined above */\n    font-size: var(--ezBannerHeaderFontSize);\n    /* ezBannerHeaderColor defined above */\n    font-weight: var(--ezBannerHeaderFontWeight);\n    /* ezBannerHeaderColor defined above */\n    font-style: var(--ezBannerHeaderFontStyle);\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\n    font-family: var(--ezFontFamily);\n}\n\n.ezText-h1-32pt-ezClockerWhite {\n    margin-top: 4px;\n    margin-bottom: 4px;\n    /* --ezClockerWhite defined in ez-body.css */\n    color: var(--ezClockerWhite);\n    /* ezBannerHeaderColor defined above */\n    font-size: var(--ezBannerHeaderFontSize);\n    /* ezBannerHeaderColor defined above */\n    font-weight: var(--ezBannerHeaderFontWeight);\n    /* ezBannerHeaderColor defined above */\n    font-style: var(--ezBannerHeaderFontStyle);\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\n    font-family: var(--ezFontFamily);\n}\n\nh2,\n.ezText-h2-22pt-ezClockerBlack {\n    margin-top: 4px;\n    margin-bottom: 4px;\n    color: var(--ezHeaderFontColor);\n    font-size: var(--ezHeaderFontSize);\n    font-weight: var(--ezHeaderFontWeight);\n    font-style: var(--ezHeaderFontStyle);\n    font-family: var(--ezFontFamily);\n}\n\n.ezText-h2-22pt-ezClockerBlack-underlined {\n    margin-top: 4px;\n    margin-bottom: 4px;\n    color: var(--ezHeaderFontColor);\n    font-size: var(--ezHeaderFontSize);\n    font-weight: var(--ezHeaderFontWeight);\n    font-style: var(--ezHeaderFontStyle);\n    font-family: var(--ezFontFamily);\n    border-bottom: 2px solid #e5e7eb;\n    padding-bottom: 6px;\n}\n\nh3,\n.ezText-h3-18pt-ezClockerNavy {\n    margin-top: 4px;\n    margin-bottom: 4px;\n    color: var(--ezTitleFontColor);\n    font-size: var(--ezTitleFontSize);\n    font-weight: var(--ezTitleFontWeight);\n    font-style: var(--ezTitleFontStyle);\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\n    font-family: var(--ezFontFamily);\n}\n\n.ezText-h3-ezClockerBlack {\n    margin-top: 4px;\n    margin-bottom: 4px;\n    /* --ezClockerBlack defined in ez-body.css */\n    color: var(--ezClockerBlack);\n    font-size: var(--ezTitleFontSize);\n    font-weight: var(--ezTitleFontWeight);\n    font-style: var(--ezTitleFontStyle);\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\n    font-family: var(--ezFontFamily);\n}\n\nh4,\n.ezText-h4-14pt-ezClockerBlack {\n    margin-top: 4px;\n    margin-bottom: 4px;\n    color: var(--ezTopicFontColor);\n    font-size: var(--ezTopicFontSize);\n    font-weight: var(--ezTopicFontWeight);\n    font-style: var(--ezTopicFontStyle);\n    font-family: var(--ezFontFamily);\n}\n\n.ezText-h4-12pt-ezClockerBlack {\n    margin-top: 4px;\n    margin-bottom: 4px;\n    color: var(--ezTopicFontColor);\n    font-size: 12pt;\n    font-weight: var(--ezTopicFontWeight);\n    font-style: var(--ezTopicFontStyle);\n    font-family: var(--ezFontFamily);\n}\n\n.ezText-main-dialog-message {\n    color: var(--ezClockerNavy);\n    font-size: 12pt;\n    font-weight: bold;\n    font-style: normal;\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\n    font-family: var(--ezFontFamily);\n}\n\n/* Header Styles */\n.ezH1 {\n    margin-top: 4px;\n    margin-bottom: 4px;\n    color: var(--ezBannerHeaderColor);\n    font-size: var(--ezBannerHeaderFontSize);\n    font-weight: var(--ezBannerHeaderFontWeight);\n    font-style: var(--ezBannerHeaderFontStyle);\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\n    font-family: var(--ezFontFamily);\n}\n\n.ezH1-ezClockerWhite {\n    margin-top: 4px;\n    margin-bottom: 4px;\n    color: var(--ezClockerWhite);\n    font-size: var(--ezBannerHeaderFontSize);\n    font-weight: var(--ezBannerHeaderFontWeight);\n    font-style: var(--ezBannerHeaderFontStyle);\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\n    font-family: var(--ezFontFamily);\n}\n\n.ezH2 {\n    margin-top: 4px;\n    margin-bottom: 4px;\n    color: var(--ezHeaderFontColor);\n    font-size: var(--ezHeaderFontSize);\n    font-weight: var(--ezHeaderFontWeight);\n    font-style: var(--ezHeaderFontStyle);\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\n    font-family: var(--ezFontFamily);\n}\n\n.ezH2-subheader {\n    margin-top: 4px;\n    margin-bottom: 4px;\n    color: var(--ezTitleFontColor);\n    font-size: var(--ezHeaderFontSize);\n    font-weight: var(--ezHeaderFontWeight);\n    font-style: var(--ezHeaderFontStyle);\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\n    font-family: var(--ezFontFamily);\n}\n\n.ezH3 {\n    margin-top: 4px;\n    margin-bottom: 4px;\n    color: var(--ezTitleFontColor);\n    font-size: var(--ezTitleFontSize);\n    font-weight: var(--ezTitleFontWeight);\n    font-style: var(--ezTitleFontStyle);\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\n    font-family: var(--ezFontFamily);\n}\n\n.ezH3-ezClockerWhite {\n    margin-top: 4px;\n    margin-bottom: 4px;\n    color: var(--ezClockerWhite);\n    font-size: var(--ezTitleFontSize);\n    font-weight: var(--ezTitleFontWeight);\n    font-style: var(--ezTitleFontStyle);\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\n    font-family: var(--ezFontFamily);\n}\n\n.ezH3_warning {\n    margin-top: 4px;\n    margin-bottom: 4px;\n    color: var(--ezClockerWarnning);\n    font-size: var(--ezTitleFontSize);\n    font-weight: var(--ezTitleFontWeight);\n    font-style: var(--ezTitleFontStyle);\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\n    font-family: var(--ezFontFamily);\n}\n\n.ezH4 {\n    margin-top: 4px;\n    margin-bottom: 4px;\n    color: var(--ezClockerNavy);\n    font-size: var(--ezTopicFontSize);\n    font-weight: var(--ezTopicFontWeight);\n    font-style: var(--ezTopicFontStyle);\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\n    font-family: var(--ezFontFamily);\n}\n\n.ezH4ActionBlue {\n    margin-top: 4px;\n    margin-bottom: 4px;\n    color: var(--ezActionFontColor);\n    font-size: var(--ezActionFontSize);\n    font-weight: var(--ezActionFontWeight);\n    font-style: var(--ezActionFontStyle);\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\n    font-family: var(--ezFontFamily);\n}\n\n/* Text Alignment Styles */\n.ezAlignRight {\n    text-align: right;\n}\n\n.ezAlignLeft {\n    text-align: left;\n}\n\n.ezAlignCenter {\n    text-align: center;\n}\n\n.ezVerticalAlignTop {\n    vertical-align: top;\n}\n\n.ezVerticalAlignMiddle {\n    vertical-align: middle;\n}\n\n.ezVerticalAlignBottom {\n    vertical-align: bottom;\n}\n\n/* Text Label Styles */\n.ezLabel {\n    color: var(--ezContentFontColor);\n    font-family: var(--ezFontFamily);\n    font-size: var(--ezContentFontSize);\n    font-style: var(--ezContentFontStyle);\n    font-weight: var(--ezContentFontWeight);\n}\n\n.ezLabel-above-input {\n    display: block;\n    color: var(--ezContentFontColor);\n    font-family: var(--ezFontFamily);\n    font-size: var(--ezContentFontSize);\n    font-style: var(--ezContentFontStyle);\n    font-weight: var(--ezContentFontWeight);\n}\n\n.ezDisabledLabel {\n    /* --ezClockerStone: #c0c0c0; (defined in ez-body.css) */\n    color: var(--ezClockerStone);\n}\n\n.ezLabel-scale-80 {\n    scale: 80%;\n    color: var(--ezContentFontColor);\n    font-family: var(--ezFontFamily);\n    font-size: var(--ezContentFontSize);\n    font-style: var(--ezContentFontStyle);\n    font-weight: var(--ezContentFontWeight);\n}\n\n\n/* Text Weight Styles */\n.ezBold {\n    font-weight: bold;\n}\n\n.ezText-strike-out {\n    text-decoration: line-through;\n}\n\n.ezText-overline {\n    text-decoration: overline;\n}\n\n.ezText-underline {\n    text-decoration: underline;\n}\n\n/* Special Text Styles */\n.ez-faded-error-details {\n    color: var(--ezLightFontColor);\n    font-family: var(--ezInputMonospaceFontFamily);\n    font-size: var(--ezSmallFontSize);\n    font-style: italic;\n}\n\n.ezText-legal-disclaimer {\n    /* --ezClockerGray: #6d6e70; (defined in ez-body.css) */\n    color: var(--ezClockerGray);\n    font-size: var(--ezMicroFontSize);\n    font-style: italic;\n}\n\n.ezText-username-info {\n    /* --ezClockerWhite: #ffffff; (defined in ez-body.css) */\n    color: var(--ezClockerWhite);\n    font-size: var(--ezSmallFontSize);\n}\n\n/* Text Classes */\n\n.ezText-bold {\n    font-family: var(--ezFontFamily);\n    font-weight: bold;\n}\n\n.ezText-data-navy {\n    color: var(--ezDataColorNavy);\n    font-family: var(--ezFontFamily);\n    font-weight: normal;\n}\n\n.ezText-navy {\n    color: var(--ezDataColorNavy);\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\n    font-family: var(--ezFontFamily);\n\n}\n\n.ezText-black {\n    color: var(--ezClockerBlack);\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\n    font-family: var(--ezFontFamily);\n}\n\n.ezText-bold-ezClockerBlack {\n    color: var(--ezClockerBlack);\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\n    font-family: var(--ezFontFamily);\n}\n\n.ezText-banner-size-32pt {\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\n    font-family: var(--ezFontFamily);\n    font-size: var(--ezBannerHeaderFontSize);\n}\n\n.ezText-header-size-22pt {\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\n    font-family: var(--ezFontFamily);\n    font-size: var(--ezHeaderFontSize);\n}\n\n.ezText-title-size-18pt {\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\n    font-family: var(--ezFontFamily);\n    font-size: var(--ezTitleFontSize);\n}\n\n.ezText-topic-size-14pt {\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\n    font-family: var(--ezFontFamily);\n    font-size: var(--ezTopicFontSize);\n}\n\n.ezText-content-size-12pt {\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\n    font-family: var(--ezFontFamily);\n    font-size: var(--ezContentFontSize);\n}\n\n.ezText-small-size-10pt {\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif; (defined in ez-body.css) */\n    font-family: var(--ezFontFamily);\n    font-size: var(--ezSmallFontSize);\n}\n\n.ezText-micro-size-8pt {\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif; (defined in ez-body.css) */\n    font-family: var(--ezFontFamily);\n    font-size: var(--ezMicroFontSize);\n}\n\n/* Small Text Classes */\n\n/* Small Black */\n.ezText-small-black {\n    /* --ezClockerBlack: #000000; (defined in ez-body.css) */\n    color: var(--ezClockerBlack);\n    font-size: var(--ezSmallFontSize);\n}\n\n/* Small White */\n.ezText-small-white {\n    /* --ezClockerWhite: #ffffff; (defined in ez-body.css) */\n    color: var(--ezClockerWhite);\n    font-size: var(--ezSmallFontSize);\n}\n\n/* Small Gray */\n.ezText-small-gray {\n    /* --ezClockerGray: #6d6e70; (defined in ez-body.css) */\n    color: var(--ezClockerGray);\n    font-size: var(--ezSmallFontSize);\n}\n\n/* Small Navy */\n.ezText-small-navy {\n    /* --ezClockerNavy: #0f4777; (defined in ez-body.css) */\n    color: var(--ezClockerNavy);\n    font-size: var(--ezSmallFontSize);\n}\n\n/* Micro Text Classes */\n\n/* Micro Black */\n.ezText-micro-black {\n    /* --ezClockerBlack: #000000; (defined in ez-body.css) */\n    color: var(--ezClockerBlack);\n    font-size: var(--ezMicroFontSize);\n}\n\n/* Micro Gray */\n.ezText-micro-gray {\n    /* --ezClockerGray: #6d6e70; (defined in ez-body.css) */\n    color: var(--ezClockerGray);\n    font-size: var(--ezMicroFontSize);\n}\n\n/* Micro Navy */\n.ezText-micro-navy {\n    /* --ezClockerNavy: #0f4777; (defined in ez-body.css) */\n    color: var(--ezDataColorNavy);\n    font-size: var(--ezMicroFontSize);\n}\n\n/* Micro Navy */\n.ezText-micro-white {\n    /* --ezClockerWhite: #ffffff; (defined in ez-body.css) */\n    color: var(--ezClockerWhite);\n    font-size: var(--ezMicroFontSize);\n}\n\n.ezText-error-ezDarkAlertRed {\n    /* --ezDarkAlertRed: #c60500; (defined in ez-body.css) */\n    color: var(--ezDarkAlertRed);\n}\n\n.ezText-success-ezClockerGreen {\n    /* --ezClockerGreen: #00B945; (defined in ez-body.css) */\n    color: var(--ezClockerGreen);\n}\n\n.ezText-radio-checkbox-label {\n    cursor: pointer;\n}\n\n.ezText-ezActiveStatusColor {\n    /* --ezDarkAlertRed: #c60500; (defined in ez-body.css) */\n    color: var(--ezActiveStateColor);\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\n    font-family: var(--ezFontFamily);\n}\n\n.ezText-ezWarningStatusColor {\n    /* --ezDarkAlertRed: #c60500; (defined in ez-body.css) */\n    color: var(--ezWarnningStateYellow);\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\n    font-family: var(--ezFontFamily);\n}\n\n.ezText-ezErrorStatusColor,\n/* deprecated */\n.ezText-ezClockerWarnning,\n/* deprecated */\n.ezText-warning-dark-alert-red {\n    /* --ezDarkAlertRed: #c60500; (defined in ez-body.css) */\n    color: var(--ezWarnningStateRed);\n    /* --ezFontFamily: 'Roboto', verdana, sans-serif (defined in ez-body.css) */\n    font-family: var(--ezFontFamily);\n}\n\n.ezText-debug-id {\n    opacity: 80%;\n    font-size: 8pt;\n    font-weight: normal;\n}\n\nu.ezText-underline-hide-alt-key-up {\n    text-decoration: none;\n    font-weight: unset;\n}\n\nu.ezText-underline-show-alt-key-down {\n    text-decoration: underline;\n    font-weight: bold;\n}\n\n.ezText-italic {\n    font-style: italic;\n}\n\n.ezText-content-color {\n    color: var(--ezContentFontColor);\n}\n\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| Horizontal Rule Separator Styles\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\nhr.ezText-separator-line-navy {\n    margin-top: 10px;\n    margin-bottom: 10px;\n    min-height: 2px;\n    /* Ignoring hint: Do not use width or height when using padding or border */\n    height: 2px;\n    background-color: var(--ezClockerNavy);\n    border-color: var(--ezClockerNavy);\n    /* Ignoring hint: Do not use width or height when using padding or border */\n    border-style: solid;\n    /* Ignoring hint: Do not use width or height when using padding or border */\n    border-width: 1px;\n    border-radius: 2px;\n}\n\n/* ------------------------------------------------------------------\n| Large Tablet Screen Styles (https://yesviz.com/laptops.php)\n------------------------------------------------------------------ */\n/*\n@media screen and (max-width: 1023px) {\n}\n*/\n\n/* ------------------------------------------------------------------\n| Small Tablet Screen Styles (https://yesviz.com/tablets.php)\n------------------------------------------------------------------ */\n/*\n@media screen and (max-width: 768px) {\n}\n*/\n\n/* ------------------------------------------------------------------\n| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 480px) {\n}\n*/\n\n/* ------------------------------------------------------------------\n| Warable Screen Style  (https://yesviz.com/watches.php)            |\n------------------------------------------------------------------- */\n@media screen and (max-width: 319px) {\n    .ezH2 {\n        margin-top: 2px;\n        margin-bottom: 2px;\n        color: var(--ezHeaderFontColor);\n        font-size: 14pt;\n        font-weight: var(--ezHeaderFontWeight);\n        font-style: var(--ezHeaderFontStyle);\n        font-family: var(--ezFontFamily);\n    }\n\n    .ezH2-subheader {\n        margin-top: 2px;\n        margin-bottom: 2px;\n        color: var(--ezTitleFontColor);\n        font-size: 14pt;\n        font-weight: var(--ezHeaderFontWeight);\n        font-style: var(--ezHeaderFontStyle);\n        font-family: var(--ezFontFamily);\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
